import { Carrier } from '../../interfaces';

export const carriers: Carrier[] = [
    { value: 'caba', label: 'CABA + Norte a 24hs hábiles' },
    { value: 'correo_custom', label: 'Correo custom' },
];
